import addPaymentMethodSchema from './addPaymentMethodSchema';

const editBankAccountSchema = {
  accountholderName: addPaymentMethodSchema.accountholderName,
  address: addPaymentMethodSchema.address,
  city: addPaymentMethodSchema.city,
  state: addPaymentMethodSchema.state,
  zipcode: addPaymentMethodSchema.zipcode,
};

export default editBankAccountSchema;
